import { writable } from "svelte/store";

export type ToastKind = "success" | "info" | "warn" | "error";

export type ToastAction = {
  label: string;
  run: () => void;
};

export type Toast = {
  id: string;
  message: string;
  kind: ToastKind;
  description?: string;
  durationMs: number;
  action?: ToastAction;
};

const store = writable<Toast[]>([]);

export const toasts = { subscribe: store.subscribe };

type Options = { description?: string; durationMs?: number; action?: ToastAction };

function emit(kind: ToastKind, message: string, opts?: Options) {
  const id = `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  const t: Toast = {
    id,
    message,
    kind,
    description: opts?.description,
    durationMs: opts?.durationMs ?? (opts?.action ? 5000 : 2600),
    action: opts?.action
  };
  store.update(list => [...list, t].slice(-4));
  if (typeof window !== "undefined") {
    window.setTimeout(() => {
      store.update(list => list.filter(x => x.id !== id));
    }, t.durationMs);
  }
}

export const toast = {
  success(msg: string, opts?: Options) {
    emit("success", msg, opts);
  },
  info(msg: string, opts?: Options) {
    emit("info", msg, opts);
  },
  warn(msg: string, opts?: Options) {
    emit("warn", msg, opts);
  },
  error(msg: string, opts?: Options) {
    emit("error", msg, opts);
  }
};

export function dismiss(id: string) {
  store.update(list => list.filter(x => x.id !== id));
}
